export const LANGUAGES = ["en", "ms"];
